import type { AxiosInstance } from "axios"

import type { CreateCreditNoteSupplementaryOrderContent } from "./creditNoteTypes"

type CreateCreditNoteRequest = Readonly<{
    orderId: number
    order: CreateCreditNoteSupplementaryOrderContent
}>

export type CreateCreditNoteResponse = Readonly<{
    order: {
        id: number
    }
}>

export async function createCreditNote(
    { orderId, order }: CreateCreditNoteRequest,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CreateCreditNoteResponse> {
    const { data } = await axios.post(
        `/orders/meetingService/${orderId}/creditNotes`,
        {
            order,
        },
        {
            signal,
        },
    )
    return data
}

export async function createSupplementaryOrder(
    { orderId, order }: CreateCreditNoteRequest,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<CreateCreditNoteResponse> {
    const { data } = await axios.post(
        `/orders/meetingService/${orderId}/supplementaryOrders`,
        {
            order,
        },
        {
            signal,
        },
    )
    return data
}
